export enum ChartCategoryEnum {
  LEASE_RATE = 'LEASE_RATE',
  REVENUE_PER_SQ_FOOT = 'REVENUE_PER_SQ_FOOT',
  REVENUE = 'REVENUE',
  LABOR_RATE = 'LABOR_RATE',
  PRICE_PER_ORDER = 'PRICE_PER_ORDER',
  SALES_PER_LABOR_HOUR= 'SALES_PER_LABOR_HOUR',
}
